export const SubItemsConfig = [
    {
      name_of_db_column: 'product',
      label_of_column: 'Product',
      order_of_column: 1,
    },
    {
      name_of_db_column: 'orderState',
      label_of_column: 'Order State',
      order_of_column: 2,
    },
    {
      name_of_db_column: 'orderPrice',
      label_of_column: 'Order Price',
      order_of_column: 3,
    },
    {
      name_of_db_column: 'requestedQuantity',
      label_of_column: 'Quantity Requested',
      order_of_column: 4,
    },
  ]
  